import React from 'react'
import { SpeakerArry } from '../constants/index'
import Arrow from '../assests/Arrow.png'
import navdbg from '../assests/navdbg.png'
import {Foot} from '../constants/index'
import searc from '../assests/searc.png'
import speak from '../assests/speak.png'
function Speakers() {
  return (
    <section className='w-full h-[820px] bg-slate-700 relative -z-20 '>
    <div className='w-full h-[500px] bg-slate-700   '>
            <div className='absolute bottom-0 right-0'><img src={navdbg} alt='nav down' className='items-end'/></div>
    
        <div className='flex flex-row justify-between mb-6'>
        <div>           
           <p className='text-[16px] font-semibold pl-10 pt-4 text-white'>GHSO24</p>
            <p className='text-[26px] font-semibold pl-10   text-white'>Side Events</p>
         </div>
         <div>
            <img src={Arrow} alt='arow' className=' pt-10 pr-10'/>
         </div>
 </div>

 <div className="relative text-gray-600 w-full ml-8 mb-6">
      <span className="absolute inset-y-0 left-0 flex items-center pl-2">
        <button type="submit" className="p-1 focus:outline-none focus:shadow-outline">
          <img src={searc} alt='search'/>
        </button>
      </span>
      <div className='flex flex-row gap-4'>
      <input type="search" name="q" className="w-[269px] h-[48px] border border-1 border-white py-2 text-sm text-white bg-gray-900 rounded-md pl-10 focus:outline-none focus:bg-white focus:text-gray-900" placeholder="Search..."/>
        
            <img src={speak} alt='log' className='w-[47px] h-[48px] border border-1 border-white bg-gray-900 rounded-md  focus:outline-none focus:bg-white '/>
        </div>
      
    </div>


       <div className='w-[330px] h-[655px] bg-white mx-auto pt-2 rounded-t-2xl relative overflow-scroll'>
           {
            SpeakerArry.map((ele)=>(
            <div className='w-full  h-[130px] mb-6 leading-5  mt-24   '>
           <img src={ele.img} alt='Logo' className='mx-auto '/>
           <p className='text-center mt-2 '>{ele.text}</p>
           <p className='text-center'>{ele.text2}</p>
           <p className='text-center'>{ele.text3}</p>

           </div>
           ))
           }
       </div>
       {/* </div> */}
    <div className='w-full rounded-t-2xl grid grid-cols-5  absolute -z-20'>
    {
        
      Foot.map((fot,i)=>(
        <div className='w-full h-[30px] ml-10 bg-white pt-6'>
           <img src={fot.im} alt='footer' className='w-[39px] h-[30px] ml-4'/>
     </div>
      ))  
      
    }
    </div>
    </div>
    </section>
  )
}

export default Speakers
